import { useSelector } from "react-redux";

import type { ReduxState } from "@dashboard/types";

export type GuestMenuVersion = "new" | "classic";

/** Which guest menu the selected restaurant's guests see. */
export const useGuestMenuVersion = (): GuestMenuVersion =>
  useSelector((state: ReduxState) =>
    state.restaurant.selectedRestaurant?.featureFlags?.find(
      (flag) => flag.flagName === "useGuestMenuV2"
    )?.flagValue === "true"
      ? "new"
      : "classic"
  );
